import React, { Component } from "react";
import { Button } from "@components";
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // New Relic isn't loaded in dev, so guard it — an unguarded call here throws inside the boundary
    // itself, which is unrecoverable and white-screens the whole app, masking the real error.
    window.newrelic?.noticeError?.(error);
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full flex flex-col items-center gap-3" role="alert">
          <h2>Something went wrong.</h2>
          <p>
            If the problem continues please reach out to us on{" "}
            <a href="mailto:support@ontik.io">support@ontik.io</a>
          </p>
          <Button
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try again
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
